import {store} from '../store/store';
import Cookies from 'js-cookie';

export default {
  ifAuthUser(to, from, next) {
    if (to.name.match(/cv-edit/)) {
      let cv_type = to.name.replace('cv-edit-','');
      store.commit("typeCv", cv_type);
    }
    if (to.name.match(/cv-show/)) {
      let cv_type = to.name.replace('cv-show-','');
      store.commit("typeCv", cv_type);
    }
    if (store.getters.authUser) {
      next();
      return;
    }
    Cookies.set("LRU", to.path, {expires: 1});
    next({name: "home", params: {lang: to.params.lang}});
  },
  redirectHome(to, from, next) {
    store.commit('loginModal', true);
    next({name: "home", params: {lang: to.params.lang}});
  },
  redirectTariff(to, from, next) {
    store.commit('paymentModal', true);
    next({name: to.params.pageName, params: {lang: to.params.lang}});
  },
  redirectBlog(to, from, next) {
    next({name: "blog", params: {lang: to.params.lang}});
  },
  ifHasPermission(to, from, next) {
    if (store.getters.authUser && store.getters.tariffsArray[to.params.v] === to.params.tariff) {
      localStorage.setItem('cv_create_tariff', to.params.tariff);
      localStorage.setItem('cv_create_version', to.params.v);
      next();
      return;
    }
    Cookies.set("LRU", to.path, {expires: 1});
    next({name: "home", params: {lang: to.params.lang}});
  },
  createCVEnter(to, from, next) {
    if (to.name.match(/cv-create/)) {
      let cv_type = to.name.replace('cv-create-','');
      store.commit("typeCv", cv_type);
    }
    next();
  }
}



// WEBPACK FOOTER //
// ./resources/js/mixins/beforeRoutesFunctions.js